import { getDinamicCSSTypes } from '../../../../helpers/dinamicTyping';

export const pdfViewerStyle = getDinamicCSSTypes({
  containerPdf: {
    height: '100vH',
    width: '100%',
  },
});
